import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import { EventCreate } from 'api/admin/models';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<EntityType<EventCreate>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const createEventDraftReducer = createReducer<State, Actions>(initialState, {
  [actions.createEvent.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.createEvent.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.createEvent.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.createEvent.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default createEventDraftReducer;
